<template>
  <span>{{timeString}}</span>
</template>

<script>
import moment from 'moment';

export default {
  name: 'DataTimeFormatter',
  data() {
    return {
      timeString: '',
    };
  },
  props: {
    dateTime: [Object, String, Date],
    formatter: String,
  },
  created() {
    if (this.dateTime) {
      this.timeString = moment(this.dateTime).format(this.formatter);
    }
  },
};
</script>

<style scoped>

</style>
